import Http from "@/services/http.js"
const document_ID = process.env.VUE_APP_BYLAW_DOCUMENT_ID;

export default{
    getDocument(){
        return Http.get(`/GetDocumentById/${document_ID}`);
    },
    getPartsByDocument(){
        return Http.get(`/GetParts/${document_ID}`);
    },
    getAllContantByDocument( ){
        var promise = Http.get(`/GetAllPartContent/${document_ID}`);
        return promise;
    },
    getContentsByPart(partId){
        return Http.get(`/GetPartContent/${partId}`);
    },
    getContentsByIdList(list){
        return Http.get(`/GetContentById/list/${document_ID}?idList=${list}`);
    },
    getSharingPathForVersion(version){
        return Http.get(`/GetSharePathUrlForVersion/${version}/${document_ID}`);
    },
    getSharingPathForDefinition(definition){
        return Http.get(`/GetSharePathUrlForDefinitionInTitle/${definition}/${document_ID}`);
    },
    getDefitition(){
        return Http.get(`/GetDefinitionsForDocument/${document_ID}`);
    },
    getSharingPathForTag(tag){
        return Http.get(`/GetSharePathUrlForTag/${tag}/${document_ID}`);
    },
    getSearchResult(keyword){
        return Http.post(`/SearchByContext/${document_ID}?keyword=${keyword}`);
    }
}